/**
 * Sensitive-data categories: one per kind of sensitive value a role can be granted, such as tax. Each
 * organisation has one `sensitive_data` object per category, `<orgId>/<category>`.
 */
export const SENSITIVE_DATA_CATEGORIES = ['tax', 'bank'] as const

export type SensitiveDataCategory = (typeof SENSITIVE_DATA_CATEGORIES)[number]

// A new category does not compile until it is added here too.
export const bySensitiveDataCategory = <V>(value: (category: SensitiveDataCategory) => V): Record<SensitiveDataCategory, V> => ({
  tax: value('tax'),
  bank: value('bank'),
})
